var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Model3dNode } from '../nodes/Model3dNode';
import { ComponentNode } from '../nodes/ComponentNode';
import { StandardViewNodes, ViewBuilder } from './ViewBuilder';
import { defaultPosition, defaultRotation } from '@canvas-logic/clp-domain';
export class PlatformBuilder {
    get assetsManager() {
        return this.builder.assetsManager;
    }
    constructor(context) {
        this.context = context;
        this.builder = new ViewBuilder(this.context);
        this.builder.registerViewNode(StandardViewNodes.Model3d, (key) => new Model3dNode(key));
        this.builder.registerViewNode(StandardViewNodes.Component, (key) => new ComponentNode(key));
    }
    buildTo(root) {
        return __awaiter(this, void 0, void 0, function* () {
            this.builder.clear();
            this.context.getTextures().forEach((texture) => {
                this.builder.addTexture(texture);
            });
            this.build(this.builder, this.context);
            return this.builder.buildTo(root);
        });
    }
    build(builder, context) {
        context.getMaterials().forEach((material) => {
            this.builder.addMaterial(material);
        });
        const parts = context.getParts();
        parts.forEach((part) => {
            var _a, _b;
            const model = context.getComponentModel(part.componentKey);
            const meshesMaterials = context.getPartMeshes(part.partKey);
            const hiddenMeshes = context.getHiddenMeshesForPart(part);
            const node = builder.addComponentNode({
                key: part.partKey,
                params: {
                    componentKey: part.componentKey,
                    meshesMaterials,
                    hiddenMeshes,
                    settings: part.settings,
                },
            });
            if (part.layout.type === 'rootPartLayout') {
                if (!model) {
                    console.warn(`No model for part ${part.partKey} found. Using default positioning`);
                }
                const layoutOptions = model ? part.layout.modelsTransforms[model.key] : undefined;
                if (layoutOptions) {
                    node.setPosition((_a = layoutOptions.translation) !== null && _a !== void 0 ? _a : defaultPosition);
                    node.setRotation((_b = layoutOptions.rotation) !== null && _b !== void 0 ? _b : defaultRotation);
                }
            }
            else {
                const parentPart = parts.find((it) => it.partKey === part.parentPartKey);
                if (!parentPart) {
                    throw new Error(`Cannot find parent part ${part.parentPartKey}`);
                }
                const mainJP = context.getComponentJointPoint(part.componentKey, part.layout.mainJointPointKey);
                const parentJP = context.getComponentJointPoint(parentPart.componentKey, part.layout.parentJointPointKey);
                builder.connectNodes({
                    parent: {
                        key: part.parentPartKey,
                        jp: parentJP,
                    },
                    child: {
                        key: part.partKey,
                        jp: mainJP,
                    },
                });
            }
        });
    }
}
//# sourceMappingURL=PlatformBuilder.js.map